import React from 'react';
import IfcViewer from './components/IfcViewer';

function App() {
  return (
    <div>
      <h2>IFC Viewer</h2>
      <IfcViewer />
    </div>
  );
}

export default App;